import { GoalType, Status, UserStatus } from 'src/app/shared/enums/enums';

export class UserAppsModel {
  id: number = 0;
  name: string = '';
  permissionGroups: Array<any> = [];
  roles: Array<RoleModel> = [];
}

export class CompanyModel {
  id: number = 0;
  name: string = '';
  userSessionTimeout: number = 0;
}

export class RoleModel {
  id: number = 0;
  name: string = '';
  userCount: number = 0;
  metadata: MetadataModel = new MetadataModel();
  app: UserAppsModel = new UserAppsModel();
  isSystemDefault: boolean = false;
  status: Status = Status.Unknown;
}

export class MetadataModel {
  createdAt: string = '';
  createdById: number = 0;
  lastModifiedAt: string = '';
  lastModifiedById: number = 0;
}

export class UserModel {
  id: number = 0;
  firstName: string = '';
  middleName: string | null = null;
  lastName: string = '';
  fullName: string = '';
  email: string = '';
  phoneNumber: string | null = null;
  companyId: number = 0;
  company: CompanyModel = new CompanyModel();
  userRoles: RoleModel[] = [];
  displayName: string = '';
  username: string = '';
  jobTitle: string = '';
  hireDate: Date = new Date();
  lastLogoutAt: Date = new Date();
  defaultGoalGroupId: number | null = null;
  defaultGoalTypeId: GoalType = GoalType.UserGoals;
  defaultLanguageId: number = 0;
  defaultModuleId: number = 0;
  defaultStoreId: number = 0;
  defaultStoreLocationId: number = 0;
  productionAutoPrint: boolean = true;
  twoFactorEnabled: boolean = true;
  productionStayScreen: boolean = false;
  productionLimit: number | null = 100;
  apps: Array<UserAppsModel> = [];
  tpmRoleId: number = 0;
  posRoleId: number = 0;
  listerRoleId: number = 0;
  imsRoleId: number = 0;
  donationRoleId: number = 0;
  roleId: number = 0;
  mustChangePasswordOnLogin: boolean = true;
  status: number = UserStatus.Active;
  statusText: string = this.status === UserStatus.Active ? 'Active' : 'Inactive';
  invitationStatus: number = 1;
  isDisabled: boolean = false;
  posStoreIds: Number[] = [];
  profileFileUrl: string = '';
  emailConfirmed: boolean = true;
  phoneNumberConfirmed: boolean = true;
  hasAccessToAdminModule: boolean = true;
  lockoutEnd: Date = new Date();
  lockoutEnabled: boolean = true;
  accessFailedCount: number = 1;
  defaultPosStoreId: number = 0;
  defaultWarehouseId: number = 0;
  imsDefaultWarehouseId: number | null = null;
  listerDefaultWarehouseLocationId: number | null = null;
  lastLoginAt: Date = new Date();
  roles: RoleModel[] = [];
}

export class UserSelfModel {
  id: number = 0;
  firstName: string = '';
  middleName: string | null = null;
  lastName: string = '';
  fullName: string = '';
  displayName: string = '';
  userName: string = '';
  email: string = '';
  phoneNumber: string | null = null;
  profileFileUrl: string = '';
}

export class ChangePasswordModel {
  id: number = 0;
  oldPassword: string = '';
  newPassword: string = '';
  conformPassVal: string = '';
}

export class StoreByUserIdModel {
  id: number = 0;
  storeId: number = 0;
  name: string = '';
  isDefault: boolean = false;
  createdAt: Date = new Date();
  CreatedById: number = 0;
  lastModifiedById: number = 0;
  isDelete: boolean = false;
}

export class UserPermissionsModel {
  appName: string = '';
  permissionGroups: UserPermissionGroupModel[] = [];
}
export class UserPermissionGroupModel {
  groupName: string = '';
  permissions: UserPermissions[] = [];
}
export class UserPermissions {
  id: number = 0;
  name: string = '';
  description: string | null = null;
}
export class RolePermissionsModel {
  id: number = 0;
  name: string = '';
  permissionSubGroups: PermissionSubGroupModel[] = [];
}

export class PermissionSubGroupModel {
  id: number = 0;
  name: string = '';
  permissions: PermissionModel[] = [];
  active: boolean = false;
}

export class PermissionModel {
  id: number = 0;
  name: string = '';
  active: boolean = false;
  isIncludedInPlan: boolean = false;
}
export class WarehouseItem {
  companyId: number = 0;
  warehouseId: string = '';
  zoneId: string = '';
  profileId: number = 0;
  name: string = '';
  isSystemDefault: boolean = false;
  aisleName: string = '';
  rackName: string = '';
  shelfName: string = '';
  binName: string = '';
  warehouse: {
    id: number;
    name: string;
  } = {
    id: -1,
    name: 'System Default',
  };
  zone: {
    id: number;
    name: string;
  } = {
    id: -1,
    name: 'System Default',
  };
  id: number = 0;
}

export class StoreLocationsModel {
  totalCount: number = 0;
  pageNumber: number = 0;
  pageSize: number = 0;
  items: WarehouseItem[] = [];
}

export class OutletsModel {
  id: number = 0;
  name: string = '';
}
export class ModulesModel {
  id: number = 0;
  name: string = '';
}

export class UserImportResponseModel {
  results: UserImportResultModel[] = [];
  totalRows: number = 0;
  successCount: number = 0;
  failureCount: number = 0;
}

export class UserImportResultModel {
  isSuccess: boolean = false;
  reason: string | null = null;
  errorMessage: string | null = null;
  rowNumber: number = 0;
  firstName: string = '';
  middleName: string | null = null;
  lastName: string = '';
  displayName: string = '';
  username: string = '';
  email: string = '';
  companyId: number = 0;
  isNewUser: boolean = false;
  userId: number | null = null;
}
